module.exports = __webpack_public_path__ + "images/newsletter1-7ec15d16da966d7deaa60be1d4320cd4.jpg";